import { NotificationPopoverItem } from '../../../services/types/Notification';

export type TopBarNotificationAction =
  | {
      type: 'SHOW';
      value: boolean;
    }
  | {
      type: 'SET_DATA';
      value: NotificationPopoverItem[];
    }
  | {
      type: 'SHOW_POPOVER_AND_SET_DATA';
      showNotificationPopover: boolean;
      popoverNotifications: NotificationPopoverItem[];
    };

export type TopBarNotificationState = {
  showNotificationPopover: boolean;
  popoverNotifications: NotificationPopoverItem[];
};

export const initialState: TopBarNotificationState = {
  showNotificationPopover: false,
  popoverNotifications: [],
};

export function reducer(
  state: TopBarNotificationState,
  action: TopBarNotificationAction
): TopBarNotificationState {
  switch (action.type) {
    case 'SHOW':
      return {
        ...state,
        showNotificationPopover: action.value,
      };

    case 'SET_DATA':
      return {
        ...state,
        popoverNotifications: [...action.value],
      };

    case 'SHOW_POPOVER_AND_SET_DATA':
      return {
        showNotificationPopover: action.showNotificationPopover,
        popoverNotifications: [...action.popoverNotifications],
      };

    default:
      return state;
  }
}
